import { statusDefinitions } from "../lib/status";
import type { WorkStatus } from "../types/domain";

export function StatusBadge({
  status,
  compact = false,
}: {
  status: WorkStatus;
  compact?: boolean;
}) {
  const definition = statusDefinitions[status];
  return (
    <span
      className={`status-badge status-badge--${definition.tone}`}
      title={definition.description}
    >
      <span className="status-badge__dot" aria-hidden="true" />
      {compact ? definition.shortLabel : definition.label}
    </span>
  );
}
